import { render, staticRenderFns } from "./Deposits.container.vue?vue&type=template&id=61b956fd&scoped=true&"
import script from "./Deposits.container.vue?vue&type=script&lang=js&"
export * from "./Deposits.container.vue?vue&type=script&lang=js&"
import style0 from "./Deposits.container.vue?vue&type=style&index=0&id=61b956fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b956fd",
  null
  
)

export default component.exports